/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { recruiterBookingInstant } from '../../axios/recruiterBookingInstant'
import type {
	RecruiterBookingInstantError,
	RecruiterBookingInstantPathParams,
	RecruiterBookingInstantResponse,
} from '../../types/RecruiterBookingInstant'

export const recruiterBookingInstantMutationKey = () =>
	[{ url: '/interview-scheduling/campaigns/:campaignId/candidates/:candidateId/instant-meeting' }] as const

export type RecruiterBookingInstantMutationKey = ReturnType<typeof recruiterBookingInstantMutationKey>

export type RecruiterBookingInstantVariables = {
	campaignId: RecruiterBookingInstantPathParams['campaignId']
	candidateId: RecruiterBookingInstantPathParams['candidateId']
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterBookingController.php RecruiterBookingController::instant */
export function useRecruiterBookingInstant<TContext = unknown>(
	options?: UseMutationOptions<
		RecruiterBookingInstantResponse,
		AxiosError<RecruiterBookingInstantError>,
		RecruiterBookingInstantVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: recruiterBookingInstantMutationKey(),
		mutationFn: ({ campaignId, candidateId }: RecruiterBookingInstantVariables) =>
			recruiterBookingInstant(campaignId, candidateId, config).then(res => res.data),
		...options,
	})
}
